import { React, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import Image from "../../../images/verifiedModal.png";
import { InputAdornment, TextField } from "@mui/material";
import { Link } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 525,
  // minWidth:303,
  bgcolor: "#FFFFFF",
  borderRadius: "24px",
  boxShadow: 24,
  p: "1rem 1.4rem ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  "@media (max-width:603px)": { width: "303px!important" },
};

export default function WithdrawModal(props) {
  // Modal use State

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        {...props}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box
              sx={{
                color: "#919191",
                marginLeft: "auto",
              }}
            >
              <CancelIcon />
            </Box>
            <Box
              component="img"
              src={Image}
              sx={{ height: "250px", width: "280px" }}
            />
            <Typography
              id="transition-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: "500", lineHeight: "2.421rem" }}
            >
              Withdraw Successful
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 1,
                fontSize: "16px!important",
                color: "#626262",
                textAlign: "center",
              }}
            >
              Your withdraw is Successfull!
            </Typography>

            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              onClick={props.onClose}
              sx={{
                textTransform: "none",
                borderRadius: "10px",
                marginTop: "2rem!important",
                mb: "1rem",
              }}
            >
              <Link className="buttonSignText" to="/withdraw">
                <span>Close</span>
              </Link>
            </Button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
